export default {
  common: {
    nav: {
      home: "ਮੁੱਖ ਸਫ਼ਾ",
      find_offer_help: "ਮਦਦ ਲੱਭੋ / ਦਿਓ",
      celebrate: "ਜ਼ਿੰਦਗੀ ਦਾ ਜਸ਼ਨ",
      family_tree: "ਪਰਿਵਾਰਕ ਰੁੱਖ",
      events: "ਈਵੈਂਟਸ",
      civic_reports: "ਨਾਗਰਿਕ ਰਿਪੋਰਟਾਂ",
      neighborhood_pulse: "ਗੁਆਂਢ ਦੀ ਧੜਕਣ",
      weather: "ਮੌਸਮ",
      nature: "ਕੁਦਰਤ",
      marketplace: "ਬਾਜ਼ਾਰ",
      news: "ਖ਼ਬਰਾਂ",
      causes: "ਉਦੇਸ਼",
      more: "ਹੋਰ",
    },
    header: { sign_in: "ਸਾਈਨ ਇਨ", join: "Social Pulse ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ", language: "ਭਾਸ਼ਾ", search: "ਖੋਜ" },
    tagline: "ਭਾਈਚਾਰਿਆਂ ਨੂੰ ਜੋੜਨਾ · ਜ਼ਿੰਦਗੀਆਂ ਨੂੰ ਸ਼ਕਤੀ ਦੇਣਾ · ਸਮਾਜਿਕ ਪੂੰਜੀ ਬਣਾਉਣਾ",
    locality: { viewing_from: "ਤੁਸੀਂ ਦੇਖ ਰਹੇ ਹੋ", change: "ਬਦਲੋ", set_your_location: "ਆਪਣੀ ਸਥਿਤੀ ਸੈੱਟ ਕਰੋ" },
    news: { title: "ਤੁਹਾਡੀ ਰੋਜ਼ਾਨਾ ਬ੍ਰੀਫਿੰਗ.", play_briefing: "ਰੋਜ਼ਾਨਾ ਬ੍ਰੀਫਿੰਗ ਚਲਾਓ", listen: "ਸੁਣੋ", translate: "ਅਨੁਵਾਦ ਕਰੋ" },
  },
};
